// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3648":"7554f5a8","7186":"ff8321a9"}[chunkId] + ".chunk.css";
};